import React from "react"

export interface UseToggleProps {
  defaultIsOpen?: boolean
  onClose?(): void
  onOpen?(): void
}

export function useToggle(props: UseToggleProps = {}) {
  const { onClose: onCloseProp, onOpen: onOpenProp, defaultIsOpen } = props

  const [isOpen, setIsOpen] = React.useState(defaultIsOpen ?? false)

  const onClose = React.useCallback(() => {
    setIsOpen(false)
    onCloseProp?.()
  }, [onCloseProp])

  const onOpen = React.useCallback(() => {
    setIsOpen(true)
    onOpenProp?.()
  }, [onOpenProp])

  const onToggle = React.useCallback(() => {
    if (isOpen) {
      onClose()
    } else {
      onOpen()
    }
  }, [isOpen, onOpen, onClose])

  return {
    isOpen: !!isOpen,
    onOpen,
    onClose,
    onToggle,
  }
}
